/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { TooltipWrapper } from '@coursera-web/cds-labs';

import { Button, breakpoints } from '@coursera/cds-core';

import useAdminPermissions from 'bundles/admin-shared/hooks/useAdminPermissions';
import TrackedButton from 'bundles/page/components/TrackedButton';

import _t from 'i18n!nls/degree-home';

import useDegree from '../utils/useDegree';

const styles = {
  adminButton: () => css`
    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
};

/** Permission-gated button to jump to the current degree's admin page */
const GoToDegreeAdmin = () => {
  const degreeResponse = useDegree();
  const permissionsResponse = useAdminPermissions();

  const degreeId = degreeResponse?.data?.Degree?.queryBySlug?.id;
  const hasPermissionToGoToAdmin = permissionsResponse?.permissions?.canViewDegreeById?.(degreeId || '');
  const degreeSlug = degreeResponse?.data?.Degree?.queryBySlug?.slug;

  if (!degreeId || !hasPermissionToGoToAdmin || !degreeSlug) {
    return null;
  }

  return (
    <div css={styles.adminButton} className="rc-ViewItemAsLearner">
      <TooltipWrapper message={_t("View this Degree's Admin page")} show={true} placement="bottom">
        <Button
          size="small"
          variant="secondary"
          onClick={() => {
            window.location.pathname = `/teach-program/${degreeSlug}`;
          }}
          component={TrackedButton}
          trackingName="go_to_degree_admin"
          withVisibilityTracking={false}
          requireFullyVisible={false}
        >
          {_t('View as admin')}
        </Button>
      </TooltipWrapper>
    </div>
  );
};

export default GoToDegreeAdmin;
